module.exports = require('./helpers/bundle-url').getBundleURL('au4zy') + "favicon.2e5f5f43.ico" + "?" + Date.now();